<div
  data-pp-message
  [attr.data-pp-placement]="page"
  data-pp-style-layout="text"
  data-pp-style-logo-type="inline"
  data-pp-style-text-size="13"
  [attr.data-pp-amount]="price"
></div>